export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/b3dc542ec1b5794376b3d1da54a4e35b.svg";